// extracted by mini-css-extract-plugin
export default {"reportManagement":"ReportManagement_reportManagement__0Pfet","contentTitle":"ReportManagement_contentTitle__RM0qi"};